import { stopPropagation } from '../../../utils/events'
import { Accordion, AccordionItem } from '../../Accordion'
import Button from '../../Button'
import Text from '../../Text'
import { Container } from '../Container'

import * as styles from './Accordions.module.css'

function Accordions() {
  return (
    <>
      <Container label='Accordion, Style-1'>
        <div>
          <Accordion className={styles.accordion} variant='style1'>
            <AccordionItem
              accordionTitle='Insurance 1'
              onDelete={e => {
                stopPropagation(e)
              }}
            >
              <Text>
                Sed ut perspiciatis unde omnis iste natus error sit voluptatem
                accusantium doloremque laudantium, totam rem aperiam, eaque ipsa
                quae ab illo inventore veritatis et quasi architecto beatae
                vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia
                voluptas sit aspernatur aut odit aut fugit, sed quia
                consequuntur magni dolores eos qui ratione voluptatem sequi
                nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor
                sit amet, consectetur, adipisci velit, sed quia non numquam eius
                modi tempora incidunt ut labore et dolore magnam aliquam quaerat
                voluptatem.
              </Text>
            </AccordionItem>

            <AccordionItem
              accordionTitle='Insurance 2'
              onDelete={e => {
                stopPropagation(e)
              }}
            >
              <Text>
                Sed ut perspiciatis unde omnis iste natus error sit voluptatem
                accusantium doloremque laudantium, totam rem aperiam, eaque ipsa
                quae ab illo inventore veritatis et quasi architecto beatae
                vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia
                voluptas sit aspernatur aut odit aut fugit, sed quia
                consequuntur magni dolores eos qui ratione voluptatem sequi
                nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor
                sit amet, consectetur, adipisci velit, sed quia non numquam eius
                modi tempora incidunt ut labore et dolore magnam aliquam quaerat
                voluptatem.
              </Text>
            </AccordionItem>

            <AccordionItem
              accordionTitle='Insurance 3Insurance 3Insurance 3Insurance 3Insurance 3Insurance 3Insurance 3Insurance 3Insurance 3'
              onDelete={e => {
                stopPropagation(e)
              }}
            >
              <Text className={styles.longButton}>
                Sed ut perspiciatis unde omnis iste natus error sit voluptatem
                accusantium doloremque laudantium, totam rem aperiam, eaque ipsa
                quae ab illo inventore veritatis et quasi architecto beatae
                vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia
                voluptas sit aspernatur aut odit aut fugit, sed quia
                consequuntur magni dolores eos qui ratione voluptatem sequi
                nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor
                sit amet, consectetur, adipisci velit, sed quia non numquam eius
                modi tempora incidunt ut labore et dolore magnam aliquam quaerat
                voluptatem.
              </Text>
            </AccordionItem>
          </Accordion>
        </div>
      </Container>

      <Container label='Accordion, Style-2'>
        <div>
          <Accordion className={styles.accordion}>
            <AccordionItem accordionTitle='Accordion'>
              <Button.Contained text='First button' />
            </AccordionItem>

            <AccordionItem accordionTitle='Accordion Accordion Accordion Accordion Accordion Accordion'>
              <Button.Contained text='Second button' />
            </AccordionItem>

            <AccordionItem accordionTitle='Accordion' staticCount={1}>
              <Button.Contained text='Third button' />
            </AccordionItem>

            <AccordionItem
              accordionTitle='Accordion Accordion Accordion Accordion Accordion Accordion'
              staticCount={2}
            >
              <Button.Contained
                className={styles.longButton}
                text='Fourth button Fourth button Fourth button Fourth button Fourth button'
              />
            </AccordionItem>
          </Accordion>
        </div>
      </Container>
    </>
  )
}

export default Accordions
